<template>
  <div style="padding-top: 0px; margin-top: 0px;">
    <v-autocomplete
      style="padding-top: 0px; margin-top: 0px; text-align: center"
      cache-items
      v-model="model"
      :items="items"
      :loading="isLoading"
      :search-input.sync="search"
      item-text="Name"
      item-value="Id"
      label="Cidade"
      hide-no-data
      placeholder="Digite nome da cidade"
      outlined
      return-object
    ></v-autocomplete>
    <v-btn v-show="model" class="botao" block @click="selecionar()">
      <v-icon small left>fas fa-check</v-icon>Continuar
    </v-btn>
  </div>
</template>

<script>
import CityService from "../services/odoo/CityService";
export default {
  props: {
    loadquote: {
      type: Object,
      default: () => ({}),
    },
  },
  data: () => ({
    descriptionLimit: 60,
    entries: [],
    isLoading: false,
    model: null,
    search: null,
    quote: null,
  }),
  async created() {
    this._cityservice = new CityService();

    // init cidade da cotação
    if (sessionStorage.getItem("current_quote")) {
      this.quote = await JSON.parse(sessionStorage.getItem("current_quote"));
      this.buscarcidades(this.quote.region.Id);
    }
  },
  methods: {
    selecionar() {
      this.$emit("evento", this.model);
    },
    clearEntries() {
      this.count = 0;
      this.entries = []; 
    },
    fetchEntriesDebounced() {
      clearTimeout(this._searchTimerId);
      this._searchTimerId = setTimeout(() => {
        this.buscarcidades();
      }, 500);
    },
    buscarcidades(cityid) {
      if (cityid || (this.search && this.search.length >= 3)) {
        this.isLoading = true;
        if (cityid) {
          this._cityservice
            .FindById(cityid)
            .then((res) => {
              if (res.data) {
                this.entries.push(res.data);
                this.count = 1;
                this.model = this.items[0];
                if (this.loadquote.loadquote) {
                  this.selecionar();
                }
              }
            })
            .finally(() => {
              this.isLoading = false;
            });
        } else if (this.search && this.search.length >= 3) {
          this._cityservice
            .FindAll(this.search)
            .then((res) => {
              if (res.data && res.data.records) {
                this.entries = res.data.records;
                this.count = res.data.totalSize;
              }
            })
            .finally(() => {
              this.isLoading = false;
            });
        }
      }
    },
  },

  computed: {
    items() {
      return this.entries.map((entry) => {
        var Description = entry.name;
        Description += entry.state_id
          ? ", " + entry.state_id.code
          : "";

        Description =
          Description.length > this.descriptionLimit
            ? Description.slice(0, this.descriptionLimit) + "..."
            : Description;

        return Object.assign(
          {},
          {
            Name: Description,
            Id: entry.id,
            label: entry.Name,
            value: entry.id,
          },
          { Description }
        );
      });
    },
  },

  watch: {
    search(val) {
      if (val) {
        this.search = val;
        this.clearEntries();
        this.isLoading = true;
        this.fetchEntriesDebounced();
      }
    },
  },
};
</script>
<style>
.botao {
  background-color: var(--v-btnprimary-base) !important;
  border-color: var(--v-btnprimary-base) !important;
  color: var(--v-foreground-base) !important;
}
</style>
